import React from 'react'
import styled from 'styled-components'
import Section from './Section'

function Home() {
	return (
		<Container>
			<Section
				title="Resilient R1"
				description="Robot feiemaskin"
				backgroundImg="render1.png"
				leftBtnText="kjøp"
			//rightBtnText="Rent"


			/>
			<Section
				title="Feature 0"
				description="Beskrivelse av reklame"
				backgroundImg="render2.png"
				leftBtnText="Kjøp"
			/>
			<Section
				title="Feature 1"
				description="Beskrivelse av reklame"
				backgroundImg="render3.png"
				leftBtnText="Kjøp"
			/>
			<Section
				title="Reservedeler"
				description=""
				backgroundImg="parts.png"
				leftBtnText="Kontakt"
			>
			</Section>
		</Container>
	)
}

export default Home

const Container = styled.div`
	height: 100vh;	
`


// WEBPACK FOOTER //
// ./src/components/Home.js